// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__3LciD","students":"index_students__23BXW"};